module.exports = __webpack_public_path__ + "static/bush-mask-8ca58aa9fe80a7c25d79cc0722ee0c7d.png";